__webpack_require__.p = "https://cdn.likepay.dev/memberchat/2.5.6/";